module.exports = "/static/assets/eb965ba88ced446fbd45955fe708beba.png";